import albumApi from "../apis/albumApi";
import { apiCallBegin, apiCallSuccess, apiCallError } from "./loading";

export const ACTION_TYPES = {
    CREATE_ALBUM: 'CREATE_ALBUM',
    UPDATE_ALBUM: 'UPDATE_ALBUM',
    DELETE_ALBUM: 'DELETE_ALBUM',
    FETCH_ALL_ALBUMS: 'FETCH_ALL_ALBUMS',
    FETCH_FIELDS_TO_FILTER_ALBUMS: 'FETCH_FIELDS_TO_FILTER_ALBUMS'
}

export const fetchAll = (artistId, pageNo, pageSize) => dispatch => {
    dispatch(apiCallBegin());
    return albumApi.album().fetchAll(artistId, pageNo, pageSize)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_ALL_ALBUMS,
                payload: response.data
            });
            dispatch(apiCallSuccess());
            return Promise.resolve(response);
        })
        .catch(err => {
            dispatch(apiCallError());
            return Promise.reject(err);
        })
}

export const create = (album, newRecord) => dispatch => {
    dispatch(apiCallBegin());
    return albumApi.album().create(newRecord)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.CREATE_ALBUM,
                payload: { ...album, id: response.data.id, artistId: response.data.artistId }
            });
            dispatch(apiCallSuccess());
            return Promise.resolve({ ...album, id: response.data.id, artistId: response.data.artistId });
        })
        .catch(err => {
            dispatch(apiCallError());
            return Promise.reject(err);
        })
}

export const update = (album, formData) => dispatch => {
    dispatch(apiCallBegin());
    return albumApi.album().update(album.id, formData)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.UPDATE_ALBUM,
                payload: album
            });
            dispatch(apiCallSuccess());
            return Promise.resolve(response);
        })
        .catch(err => {
            dispatch(apiCallError());
            return Promise.reject(err);
        })
}

export const deleteAlbum = (id) => dispatch => {
    dispatch(apiCallBegin());
    return albumApi.album().delete(id)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.DELETE_ALBUM,
                payload: id
            });
            dispatch(apiCallSuccess());
            return Promise.resolve(response);
        })
        .catch(err => {
            dispatch(apiCallError());
            return Promise.reject(err);
        })
}

export const togglePublish = (album) => dispatch => {
    dispatch(apiCallBegin());
    return albumApi.album().togglePublish(album.id, album.isPublished)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.UPDATE_ALBUM,
                payload: album
            });
            dispatch(apiCallSuccess());
            return Promise.resolve(response);
        })
        .catch(err => {
            dispatch(apiCallError());
            return Promise.reject(err);
        })
}

export const toggleForSale = (album) => dispatch => {
    dispatch(apiCallBegin());
    return albumApi.album().toggleForSale(album.id, album.isForSale)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.UPDATE_ALBUM,
                payload: album
            });
            dispatch(apiCallSuccess());
            return Promise.resolve(response);
        })
        .catch(err => {
            dispatch(apiCallError());
            return Promise.reject(err);
        })
}

export const fetchFieldsToFilter = () => dispatch => {
    dispatch(apiCallBegin());
    return albumApi.album().fetchFieldsToFilter()
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_FIELDS_TO_FILTER_ALBUMS,
                payload: response.data
            });
            dispatch(apiCallSuccess());
            return Promise.resolve(response);
        })
        .catch(err => {
            dispatch(apiCallError());
            return Promise.reject(err);
        })
}